



































import Vue from 'vue';
import {mapGetters, mapState} from 'vuex';
import {httpService} from "@/modules/core/services/http-service";

export default Vue.extend({
  name: 'UserOptions',
  computed: {
    ...mapState('navigation', ['sidebarMini']),
    ...mapGetters('authorisationStore', ['isAuthenticated', 'getUserEmail']),
    ...mapState('authorisationStore', ['userProfile']),
    getClassForUser(){
      const output = ['user-details'];

      if(this.sidebarMini){
        output.push('mini')
      }
      return output;
    }
  },
  methods: {
    async logout() {
      await httpService.logOut()
    },
    async login() {
      await httpService.logIn()
    },
  },
});
